import LoadingSpinner from './LoadingSpinner';
import './LoadingSpinner.css';

export default LoadingSpinner;



// WEBPACK FOOTER //
// ./src/components/LoadingSpinner/index.js